/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * Auth service
 * JWT, OAuth, SAML and service-to-service auth routes
 * OpenAPI spec version: 1.0.0
 */
import {
  useMutation
} from '@tanstack/react-query';
import type {
  MutationFunction,
  UseMutationOptions,
  UseMutationResult
} from '@tanstack/react-query';

import type {
  PostAuthGoogle200,
  PostAuthGoogleBody
} from '.././schemas';

import { axiosAuth } from '../../../../lib/axiosAuth';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;




/**
 * @summary Exchange a Google One-Tap ID token for application tokens
 */
export const postAuthGoogle = (
    postAuthGoogleBody: PostAuthGoogleBody,
 signal?: AbortSignal
) => {
      
      
      return axiosAuth<PostAuthGoogle200>(
      {url: `/auth/google`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: postAuthGoogleBody, signal
    },
      );
    }
  


export const getPostAuthGoogleMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthGoogle>>, TError,{data: PostAuthGoogleBody}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<typeof postAuthGoogle>>, TError,{data: PostAuthGoogleBody}, TContext> => {

const mutationKey = ['postAuthGoogle'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof postAuthGoogle>>, {data: PostAuthGoogleBody}> = (props) => {
          const {data} = props ?? {};

          return  postAuthGoogle(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type PostAuthGoogleMutationResult = NonNullable<Awaited<ReturnType<typeof postAuthGoogle>>>
    export type PostAuthGoogleMutationBody = PostAuthGoogleBody
    export type PostAuthGoogleMutationError = void

    /**
 * @summary Exchange a Google One-Tap ID token for application tokens
 */
export const usePostAuthGoogle = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof postAuthGoogle>>, TError,{data: PostAuthGoogleBody}, TContext>, }
 ): UseMutationResult<
        Awaited<ReturnType<typeof postAuthGoogle>>,
        TError,
        {data: PostAuthGoogleBody},
        TContext
      > => {

      const mutationOptions = getPostAuthGoogleMutationOptions(options);

      return useMutation(mutationOptions );
    }
    